export const GET_FAMILY_CLANS_REQUEST = "GET_FAMILY_CLANS_REQUEST";
export const GET_FAMILY_CLANS_SUCCESS = "GET_FAMILY_CLANS_SUCCESS";
export const GET_FAMILY_CLANS_FAILURE = "GET_FAMILY_CLANS_FAILURE";
export const GET_FAMILY_CLAN_REQUEST = "GET_FAMILY_CLAN_REQUEST";
export const GET_FAMILY_CLAN_SUCCESS = "GET_FAMILY_CLAN_SUCCESS";
export const GET_FAMILY_CLAN_FAILURE = "GET_FAMILY_CLAN_FAILURE";
export const GET_FAMILY_CLAN_ANALYTICS_REQUEST =
  "GET_FAMILY_CLAN_ANALYTICS_REQUEST";
export const GET_FAMILY_CLAN_ANALYTICS_SUCCESS =
  "GET_FAMILY_CLAN_ANALYTICS_SUCCESS";
export const GET_FAMILY_CLAN_ANALYTICS_FAILURE =
  "GET_FAMILY_CLAN_ANALYTICS_FAILURE";
export const GET_FAMILY_CLAN_HISTORY_REQUEST =
  "GET_FAMILY_CLAN_HISTORY_REQUEST";
export const GET_FAMILY_CLAN_HISTORY_SUCCESS =
  "GET_FAMILY_CLAN_HISTORY_SUCCESS";
export const GET_FAMILY_CLAN_HISTORY_FAILURE =
  "GET_FAMILY_CLAN_HISTORY_FAILURE";
export const GET_FAMILY_CLAN_RANKING_REQUEST = "GET_FAMILY_CLAN_RANKING_REQUEST";
export const GET_FAMILY_CLAN_RANKING_SUCCESS = "GET_FAMILY_CLAN_RANKING_SUCCESS";
export const GET_FAMILY_CLAN_RANKING_FAILURE = "GET_FAMILY_CLAN_RANKING_FAILURE";
export const CLEAR_FAMILY_CLAN = "CLEAR_FAMILY_CLAN";
